import { SET_ACTIVE_ORDERS_TAB } from "./actionTypes";

export const setActiveOrdersTab = (tabIndex) => ({
    type: SET_ACTIVE_ORDERS_TAB,
    tabIndex,
});
